import { RouterProvider } from 'react-router-dom'
import router from './router'

function Router() {
  return (
    <RouterProvider
      future={{
        v7_startTransition: true
      }}
      router={router}
    />
  )
}

export default Router
